import React from 'react'
import { useEffect, useState } from 'react';
import './ComponentsCss/LawyerCard.css';
const LawyerCard = ({ lawyerData }) => {

    useEffect(() => {
        //console.log("LAwyer Data" + JSON.stringify(lawyerData, null, 2));

        const tempEdu = lawyerData[0]?.lawyerEducation.split(":");
        const tempExp = lawyerData[0]?.lawyerExperience.split(":");
        // const answer_array = answer.split(',');
        SetLawyerEduList(tempEdu);
        SetLawyerExpList(tempExp);
    }, [lawyerData]);

    const [lawyerEduList, SetLawyerEduList] = useState();
    const [lawyerExpList, SetLawyerExpList] = useState();
    const [isExpanded, setIsExpanded] = useState(false); // Toggle state for show more/less

    // 
    return (
        <div className="lawyer-card-flex-col">
        <div className="lawyer-card-flex-row">
          <img
            src={`https://stepupkorea.kr/images/lawyers/${lawyerData[0]?.lawyerImage}`}
            className="lawyer-card-profile-icon"
            alt="lawyer profile"
          />
          <div className="laywer-card-abstract">
            <div className="lawyer-card-big-text">
              {lawyerData[0]?.lawyerName} 변호사
            </div>
            <div className="lawyer-card-sub-text lawyer-card-light-color">
              {lawyerData[0]?.lawyerAsso}
            </div>
          </div>
        </div>
  
        {/* Conditional Rendering of Education and Experience */}
        {isExpanded && (
          <div className="lawyer-card-details">
            <ul>
              <div className="lawyer-card-big-text">학력</div>
              {lawyerEduList.length > 0 ? (
                lawyerEduList.map((edu, index) => <li key={index}>{edu}</li>)
              ) : (
                <li>학력 정보가 없습니다.</li>
              )}
            </ul>
  
            <ul>
              <div className="lawyer-card-big-text">주요 경력</div>
              {lawyerExpList.length > 0 ? (
                lawyerExpList.map((exp, index) => <li key={index}>{exp}</li>)
              ) : (
                <li>경력 정보가 없습니다.</li>
              )}
            </ul>
          </div>
        )}
        {/* Show More/Show Less Button */}
  
        <button
          className="lawyer-card-toggle-btn"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Show Less" : "Show More"}
        </button>
      </div>
    )
}

export default LawyerCard